<template>
  <section>
    <div class="scrollable-content">
      <b-collapse
        class="card"
        v-for="(type, idx) in types"
        :key="idx"
      >
        <div
          slot="trigger"
          slot-scope="props"
          class="card-header"
          role="button"
        >
          <p class="card-header-title">
            <span class="is-padded-small">
              <div
                class="circle"
                :class="backgroundByAgentCategory(agents[type][0].agent_type)"
              /><span class="has-margin-horizontal-small">{{ `${agentCategoryLabel(type)} (${agents[type].length})` }}</span>
            </span>
          </p>
          <div class="flex-pull-right is-padded-small has-margin-horizontal-small">
            <font-awesome-icon
              :icon="props.open ? 'caret-up' : 'caret-down'"
              size="2x"
            />
          </div>
        </div>
        <div
          class="card-content is-paddingless"
          :class="colorByAgentCategory(agents[type][0].agent_type)"
        >
          <observation-result-basket-list-item
            v-for="agent in agents[type]"
            class="has-background-secondary-bg"
            :key="agent.id"
            :agent="agent"
            @list-item-clicked="closeResultList"
          />
        </div>
      </b-collapse>
    </div>
  </section>
</template>

<script>
import ObservationResultBasketListItem from './ObservationResultBasketListItem'
import { colorByAgentCategory } from '@/mixins'
import { mapGetters } from 'vuex'

export default {
  components: {
    ObservationResultBasketListItem
  },
  props: {
    agents: {
      type: Object
    }
  },
  computed: {
    ...mapGetters(['agentCategoryLabel']),
    types () {
      return Object.keys(this.agents)
    }
  },
  mixins: [colorByAgentCategory],
  methods: {
    closeResultList () {
      this.$emit('list-item-clicked')
    },
  }
}
</script>

<style lang="scss" scoped>
@import "./src/assets/colorpallet.scss";

.circle {
  vertical-align: middle;
  display: inline-block;
  border-radius: 50px;
  height: 1rem;
  width: 1rem;
}

section {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  /* for Firefox */
  min-height: 0;
}

.scrollable-content {
  flex-grow: 1;
  overflow: auto;
  /* for Firefox */
  min-height: 0;
}

.card-content {
  padding: 2px 5px 2px 5px;
  border-left: 10px solid;

  &.CAgent {
    border-color: $CAgent;
  }

  &.BAgent {
    border-color: $BAgent;
  }

  &.RNAgent {
    border-color: $RNAgent;
  }
}
</style>
